import { getAdditionalInfoVal } from '../getAdditionalInfoVal';
import { CARDS_INFO_KEY } from '../../constants/cards';
export var getIsPayFromPost = function (post) {
    var cards = JSON.parse(getAdditionalInfoVal(post === null || post === void 0 ? void 0 : post.additionalInfo, CARDS_INFO_KEY) || '[]') || [];
    return cards === null || cards === void 0 ? void 0 : cards.every(function (card) { return card === null || card === void 0 ? void 0 : card.isPay; });
};
//# sourceMappingURL=getIsPayFromPost.js.mapimport { getAdditionalInfoVal } from '../getAdditionalInfoVal';
import { CARDS_INFO_KEY } from '../../constants/cards';
export var getIsPayFromPost = function (post) {
    var cards = JSON.parse(getAdditionalInfoVal(post === null || post === void 0 ? void 0 : post.additionalInfo, CARDS_INFO_KEY) || '[]') || [];
    return cards === null || cards === void 0 ? void 0 : cards.every(function (card) { return card === null || card === void 0 ? void 0 : card.isPay; });
};
//# sourceMappingURL=getIsPayFromPost.js.map